import { render } from "./Place.vue?vue&type=template&id=2c8bc53e"
import script from "./Place.vue?vue&type=script&lang=js"
export * from "./Place.vue?vue&type=script&lang=js"
script.render = render

export default script